import { h, render } from 'preact'
import { QrApp } from './qr-app'

render(<QrApp />, document.getElementById('app'))
